const apiUrl = process.env.REACT_APP_API_URL;
export const DeleteAulaIdProjectesIdTasques = async (id_aula: string, id_projecte: string, id_tasca: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${id_aula}/projectes/${id_projecte}/tasques/${id_tasca}`, {
            method: 'DELETE',
        });
        if (response.ok) {
            return true;
        } else {
            console.error(await response.text());
            return false;
        }
    } catch (error) {
        console.error('Error al delete:', error);
        return false;
    }
};
